import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

const inputCls =
  "w-full bg-white border border-[#E2E8E4] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#1D6B2A] focus:ring-4 focus:ring-[#4CAF50]/15 transition-all";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-5 py-16 bg-[#F8FAF8]">
      <div className="w-full max-w-md bg-white border border-[#E2E8E4] rounded-3xl p-8 shadow-sm">
        <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#1D6B2A] text-white mx-auto">
          <Lock size={22} />
        </span>
        <h1 className="font-head text-2xl font-semibold text-[#0A1C0E] text-center mt-4">Admin Login</h1>
        <p className="text-[#3A4D3E] text-sm text-center mt-1">Manage the Chennai Packs blog</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password" />
          {error && <p className="text-sm text-red-600" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-[#1D6B2A] text-white rounded-full px-8 py-3.5 font-semibold hover:bg-[#154d1e] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 size={18} className="animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
